import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { track } from '@xanadu/ui-shared/interfaces/woopra';
import { getFlag } from '../../configureFlags';

import { APP_STORE_URLS } from '../../constants';

import IconClose from '../../../images/icons/misc/close.svg';
import { getMobileOS } from '@xanadu/ui-shared/utils/deviceDetection';

import useCMSContent from './hooks/useCMSContent';

import styles from './NativeAppsPopup.module.scss';

const OS_SYSTEM = getMobileOS();

const NativeAppsPopup = ({ onClose }) => {
  const [show, setShow] = useState(false);
  const [showPhoneImage, setShowPhoneImage] = useState(false);
  const { text, backgroundImage, phoneImage, error } = useCMSContent();

  useEffect(() => {
    let timeoutMount = null;
    let timeoutPhoneImage = null;

    if (text && backgroundImage && phoneImage) {
      timeoutMount = setTimeout(() => {
        setShow(true);

        timeoutPhoneImage = setTimeout(() => {
          setShowPhoneImage(true);
        }, 400);
      }, 400);
    }

    return () => {
      clearTimeout(timeoutMount);
      clearTimeout(timeoutPhoneImage);
    };
  }, [text, backgroundImage, phoneImage]);

  const getUserReturningFlag = () => getFlag('mb-user-returning-times');

  const handleClose = () => {
    track('Marketing', 'Native App Popup - Close', {
      os: OS_SYSTEM,
      userReturningTimes: getUserReturningFlag(),
    });

    onClose();
  };

  const mainClass = classNames({
    [styles.main]: true,
    [styles['main--visible']]: show
  });

  const phoneImageClass = classNames({
    [styles.phoneImage]: true,
    [styles['phoneImage--visible']]: showPhoneImage
  });

  const downloadIconClass = classNames({
    [styles.downloadIcon]: true,
    [styles[`downloadIcon--${OS_SYSTEM}`]]: show
  });

  if (error) {
    return null;
  }

  return (
    <div className={mainClass}>
      {backgroundImage && (
        <div
          className={styles.container}
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <span className={styles.containerClose} role="button">
            <IconClose onClick={handleClose} />
          </span>
          <div className={styles.head}>
            <span className={styles.logo} />
            <span>Get the App</span>
          </div>
          <div className={styles.textContainer}>
            <span>{text}</span>
          </div>
          <div className={styles.downloadContainer}>
            <span className={styles.downloadNow}>DOWNLOAD NOW</span>
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <a
              className={downloadIconClass}
              onClick={() => {
                track('Marketing', 'Native App Popup - Download', {
                  os: OS_SYSTEM,
                  type: 'download',
                  source: 'play store',
                  userReturningTimes: getUserReturningFlag(),
                });
              }}
              href={APP_STORE_URLS[OS_SYSTEM]}
            />
            {OS_SYSTEM === 'Android' && (
              <p className={styles.notAvailableStore}>
                <span>Not available in your store?</span>
                <Link
                  className={styles.link}
                  onClick={() => {
                    track('Marketing', 'Native App Popup - Download', {
                      os: OS_SYSTEM,
                      type: 'download',
                      source: 'internal link',
                      userReturningTimes: getUserReturningFlag(),
                    });

                    onClose();
                  }}
                  to="/page/about/mobile-applications/"
                >Download the Android App here</Link>
              </p>
            )}
          </div>
          <div
            className={phoneImageClass}
            style={{ backgroundImage: `url(${phoneImage})` }}
          />
        </div>
      )}
    </div>
  );
};

NativeAppsPopup.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default NativeAppsPopup;
